import * as React from 'react';

import {Field} from 'redux-form';

import {FormField} from 'shells/form/form-field';
import {Body} from 'shells/typography/body';

import styles from './spam-prevention-form.module.css';

export function SpamPreventionForm() {
    return (
        <div className={styles['spam-prevention-form']}>
            <div className={styles['form-description']}>
                Protecting spam submissions is important to ensure the data entering Nutshell is
                accurate and effective. Choose your preferred level of spam protection below.
            </div>
            <FormField innerId='SPAM_PREVENTION_MOSTLY_INVISIBLE'>
                <div className={styles['radio-row']}>
                    <label className={styles['form-label']}>
                        <Field
                            name='spamPreventionType'
                            component='input'
                            type='radio'
                            value='SPAM_PREVENTION_MOSTLY_INVISIBLE'
                        />
                        Mostly invisible&nbsp; <i style={{fontWeight: 'normal'}}>(recommended)</i>
                    </label>
                </div>
                <div style={{paddingLeft: 22}}>
                    <Body color='light'>
                        We’ll only show the below captcha to suspected spammers. This means your
                        form will look exactly the same
                    </Body>
                </div>
            </FormField>
            <FormField innerId='SPAM_PREVENTION_ALWAYS_ON'>
                <div className={styles['radio-row']}>
                    <label className={styles['form-label']}>
                        <Field
                            name='spamPreventionType'
                            component='input'
                            type='radio'
                            value='SPAM_PREVENTION_ALWAYS_ON'
                        />
                        Always on
                    </label>
                </div>
                <div style={{paddingLeft: 22}}>
                    <Body color='light'>We’ll show the captcha image below to every submitter</Body>
                </div>
            </FormField>
            <FormField innerId='SPAM_PREVENTION_OFF'>
                <div className={styles['radio-row']}>
                    <label className={styles['form-label']}>
                        <Field
                            name='spamPreventionType'
                            component='input'
                            type='radio'
                            value='SPAM_PREVENTION_OFF'
                        />
                        No protection
                    </label>
                </div>
                <div style={{paddingLeft: 22}}>
                    <Body color='light'>
                        No spam protection enabled for this form. We won’t try to block spammers or
                        show a captcha to any submitters.{' '}
                        <strong>This option is not recommended!</strong>
                    </Body>
                </div>
            </FormField>
        </div>
    );
}
